"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3827],{

/***/ 60108:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E2": function() { return /* binding */ TabItem; },
/* harmony export */   "He": function() { return /* binding */ CompanyContent; },
/* harmony export */   "MV": function() { return /* binding */ EmptyFollowedStyle; },
/* harmony export */   "d0": function() { return /* binding */ TabMenu; },
/* harmony export */   "jE": function() { return /* binding */ CompanyBlockHeader; },
/* harmony export */   "og": function() { return /* binding */ ViewAllButton; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19521);
/* harmony import */ var _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39724);
/* harmony import */ var _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18978);
/* harmony import */ var _CompanyItem_CompanyItem_css__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94737);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    margin: -8px;\n    padding: 16px 0;\n    @media screen and (min-width: 768px) {\n        padding-bottom: 0;\n    }\n    > div {\n        display: inline-flex;\n        width: 32%;\n        margin: 8px;\n        @media screen and (max-width: 425px) {\n            width: calc(100% - 16px);\n        }\n        @media screen and (min-width: 426px) and (max-width: 1024px) {\n            width: calc(50% - 16px);\n        }\n        @media screen and (min-width: 1025px) and (max-width: 1680px) {\n            width: calc(33% - 16px);\n        }\n    }\n    ",
        " {\n        flex-direction: column;\n    }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    overflow-x: auto;\n    /* Hide scrollbar for Chrome, Safari and Opera */\n    ::-webkit-scrollbar {\n        display: none;\n    }\n\n    /* Hide scrollbar for IE, Edge and Firefox */\n    -ms-overflow-style: none;  /* IE and Edge */\n    scrollbar-width: none;  /* Firefox */\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n    line-height: 17px;\n    font-size: 14px;\n    padding: 0 8px 10px 8px;\n    cursor: pointer;\n    font-weight: ",
        ";\n    color: ",
        ";\n    border-bottom:",
        ";\n    white-space: nowrap;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n            a {\n                display: block;\n                width: 100%;\n                background-color: #f2f7ff;\n                border-radius: 6px;\n                text-align: center;\n                padding: 12px 0;\n                margin-top: 8px;\n            }\n        "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n    text-align: right;\n    a {\n        color: #005aff;\n        text-decoration: none;\n    }\n    &:hover {\n        a {\n            color: #ff7d55;\n        }\n        svg {\n            path {\n                fill: #ff7d55;\n            }\n        }\n    }\n    ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}



var CompanyBlockHeader = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_microfrontends_react_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-1da2b5e6-0"
})(_templateObject());
var CompanyContent = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_microfrontends_react_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-1da2b5e6-1"
})(_templateObject1(), _CompanyItem_CompanyItem_css__WEBPACK_IMPORTED_MODULE_0__/* .CompanyItemWrapper */ .uA);
var TabMenu = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_microfrontends_react_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-1da2b5e6-2"
})(_templateObject2());
var TabItem = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-1da2b5e6-3"
})(_templateObject3(), function(param) {
    var isActive = param.isActive;
    return isActive ? "700" : "400";
}, function(param) {
    var isActive = param.isActive;
    return isActive ? "#005aff" : "#666";
}, function(param) {
    var isActive = param.isActive;
    return isActive ? "2px solid #005aff" : "2px solid transparent";
});
var ViewAllButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_microfrontends_react_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-1da2b5e6-4"
})(_templateObject5(), function(param) {
    var isBottom = param.isBottom;
    if (!isBottom) {
        return "";
    }
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject4());
});
var EmptyFollowedStyle = {
    backgroundColor: "#F9F9F9",
    marginTop: 20
};


/***/ }),

/***/ 94737:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D8": function() { return /* binding */ CoverWrapper; },
/* harmony export */   "Dc": function() { return /* binding */ CompanyLogo; },
/* harmony export */   "IH": function() { return /* binding */ ContentSection; },
/* harmony export */   "So": function() { return /* binding */ FollowCount; },
/* harmony export */   "ag": function() { return /* binding */ CompanyHeader; },
/* harmony export */   "n6": function() { return /* binding */ FollowSection; },
/* harmony export */   "nq": function() { return /* binding */ BannerSection; },
/* harmony export */   "uA": function() { return /* binding */ CompanyItemWrapper; },
/* harmony export */   "wU": function() { return /* binding */ CompanyJob; },
/* harmony export */   "zW": function() { return /* binding */ CompanyInfo; },
/* harmony export */   "zo": function() { return /* binding */ CompanyName; }
/* harmony export */ });
/* unused harmony export CompanyCategories */
/* harmony import */ var _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67430);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19521);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    100% {\n        transform: translateX(100%);\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n    width: calc(100% - 16px);\n    display: inline-block;\n    margin-right: 16px;\n    margin-bottom: 16px;\n    border-radius: 6px;\n    padding: 8px;\n    background-color: #fff;\n    border: 1px solid #eee;\n    &:nth-child(3n) {\n        margin-right: 0;\n    }\n    @media screen and (max-width: ",
        "px) {\n        width: calc(100% - 16px);\n    }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    color: #999;\n    display: flex;\n    justify-content: space-between;\n    font-size: 12px;\n    line-height: 24px;\n    width: 100%;\n    right: 25px;\n    bottom: 15px;\n\n    > svg {\n        margin-right: 2px;\n        vertical-align: top;\n    }\n    > button {\n        font-size: 12px;\n        height: 24px;\n        line-height: 24px;\n        padding: 2px 2px;\n        letter-spacing: -0.2px;\n    }\n    > span {\n        letter-spacing: -0.2px;\n    }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n    position: relative;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n    width: 100%;\n    height: 0;\n    padding-top: calc(1 / (64 / 17) * 100%);\n    border-radius: 6px;\n    border-bottom-right-radius: 0px;\n    border-bottom-left-radius: 0px;\n    position: relative;\n    overflow: hidden;\n    margin-bottom: 8px;\n    img {\n        object-fit: cover;\n    }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    padding: 0 8px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n    flex-grow: 1;\n    padding: 12px 12px 0 12px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n    display: block;\n    min-width: 88px;\n    max-width: 88px;\n    width: 88px;\n    height: 88px;\n    position: relative;\n    border-radius: 6px;\n    overflow: hidden;\n    background-color: #fff;\n\n    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.26);\n    img {\n        object-fit: contain;\n        padding: 8px !important;\n    }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n    padding: 16px 8px 8px 8px;\n    height: 172px;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n    display: block;\n    padding: 12px 16px;\n    border-radius: 12px;\n    border: 1px solid #f1f1f1;\n    margin-bottom: 8px;\n    p {\n        overflow: hidden;\n        white-space: nowrap;\n        text-overflow: ellipsis;\n        margin-bottom: 0px;\n        line-height: 18px;\n    }\n    .job-title {\n        font-size: 14px;\n        font-weight: 600;\n        line-height: 18px;\n        letter-spacing: 0px;\n        text-align: left;\n        margin-bottom: 4px;\n    }\n    .job-salary {\n        color: #ff7d55;\n        font-size: 14px;\n    }\n    .job-location {\n        color: #797979;\n        font-size: 14px;\n    }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n    font-weight: 500;\n    font-size: 18px;\n    line-height: 22px;\n    color: #333;\n    margin-bottom: 6px;\n    width: fit-content;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 1;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n    font-size: 14px;\n    line-height: 17px;\n    height: 17px;\n    color: ",
        ";\n    width: fit-content;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 1;\n    margin-bottom: 6px;\n    word-break: break-all;\n    svg {\n        vertical-align: top;\n        margin-right: 3px;\n        margin-top: 2px;\n    }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n    padding: 0 8px 16px 8px;\n    button {\n        width: 100%;\n    }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}


var shimmer = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .keyframes */ .F4)(_templateObject());
var CompanyItemWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-69bb922f-0"
})(_templateObject1(), _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_1__/* .screens.mobile */ .FB.mobile);
var FollowCount = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-69bb922f-1"
})(_templateObject2());
var BannerSection = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-69bb922f-2"
})(_templateObject3());
var CoverWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-69bb922f-3"
})(_templateObject4());
var CompanyHeader = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-69bb922f-4"
})(_templateObject5());
var CompanyInfo = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-69bb922f-5"
})(_templateObject6());
var CompanyLogo = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].a.withConfig */ .ZP.a.withConfig({
    componentId: "sc-69bb922f-6"
})(_templateObject7());
var ContentSection = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-69bb922f-7"
})(_templateObject8());
var CompanyJob = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-69bb922f-8"
})(_templateObject9());
var CompanyName = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].a.withConfig */ .ZP.a.withConfig({
    componentId: "sc-69bb922f-9"
})(_templateObject10());
var CompanyCategories = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-69bb922f-10"
})(_templateObject11(), function(param) {
    var color = param.color;
    return color;
});
var FollowSection = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-69bb922f-11"
})(_templateObject12());


/***/ }),

/***/ 70135:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ Title; },
/* harmony export */   "j": function() { return /* binding */ ContainerWrapper; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19521);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n            margin-bottom: ",
        "px;\n        "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n            margin-right: ",
        "px;\n        "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n            margin-top: ",
        "px;\n        "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n            margin-left: ",
        "px;\n        "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n    background-color: #fff;\n    border-radius: 6px;\n    padding: 24px;\n    display: ",
        ";\n    ",
        "\n    ",
        "\n    ",
        "\n    ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n            padding-right: ",
        "px;\n        "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n    font-size: ",
        "px;\n    line-height: 15px;\n    font-weight: 700;\n    margin-bottom: ",
        ";\n    color: ",
        ";\n    ",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}

var ContainerWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-c20aa420-0"
})(_templateObject4(), function(param) {
    var isFlex = param.isFlex;
    return isFlex ? "flex" : "block";
}, function(param) {
    var marginBottom = param.marginBottom;
    if (!marginBottom) {
        return "";
    }
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(_templateObject(), marginBottom);
}, function(param) {
    var marginRight = param.marginRight;
    if (!marginRight) {
        return "";
    }
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(_templateObject1(), marginRight);
}, function(param) {
    var marginTop = param.marginTop;
    if (!marginTop) {
        return "";
    }
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(_templateObject2(), marginTop);
}, function(param) {
    var marginLeft = param.marginLeft;
    if (!marginLeft) {
        return "";
    }
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(_templateObject3(), marginLeft);
});
var Title = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].p.withConfig */ .ZP.p.withConfig({
    componentId: "sc-c20aa420-1"
})(_templateObject6(), function(param) {
    var fontSize = param.fontSize;
    return fontSize ? fontSize : 16;
}, function(param) {
    var removeSpace = param.removeSpace;
    return removeSpace ? "0" : "16px";
}, function(param) {
    var color = param.color;
    return color ? color : "#333";
}, function(param1) {
    var paddingRight1 = param1.paddingRight;
    if (!paddingRight1) {
        return "";
    }
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(_templateObject5(), function(param) {
        var paddingRight = param.paddingRight;
        return paddingRight;
    });
});


/***/ }),

/***/ 46114:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EJ": function() { return /* binding */ MostUsageCVWrapper; },
/* harmony export */   "W4": function() { return /* binding */ ButtonWrapper; },
/* harmony export */   "Wh": function() { return /* binding */ MostUsageTitle; },
/* harmony export */   "lo": function() { return /* binding */ CVPreview; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _CompanyBlock_CompanyBlock_css__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(60108);
/* harmony import */ var _Container_Container_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70135);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    margin-right: -16px;\n    ",
        " {\n        background-color: #F2F7FF;\n        border-radius: 6px;\n        width: calc(100% - 16px);\n        padding: 12px 0;\n        text-align: center;\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n    width: 50%;\n    @media (max-width: 767px) {\n        width: 100%;\n    }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    display: none;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n            @media screen and (max-width: 768px) {\n                width: 100%;\n            }\n        "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n    display: inline-block;\n    width: 100%;\n    border: 1px solid #e2e2e2;\n    border-radius: 6px;\n    margin-right: 16px;\n    aspect-ratio: 0.7073;\n    object-fit: cover;\n    position:  relative;\n    img {\n        border-radius: 6px;\n    }\n    @media screen and (max-width: 768px) {\n        width: calc(100% - 16px);\n    }\n    &:hover {\n        &::before {\n            content: ' ';\n            background-color: rgba(0, 0, 0, 0.7);\n            border-radius: 6px;\n            display: block;\n            position: absolute;\n            top: 0;\n            left: 0;\n            width: 100%;\n            height: 100%;\n            z-index: 1;\n        }\n        ",
        " {\n            position: absolute;\n            z-index: 2;\n            left: 0;\n            top: 0;\n            width: 100%;\n            height: 100%;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            border-radius: 6px;\n        }\n    }\n    ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}



var MostUsageCVWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-1668e65a-0"
})(_templateObject(), _CompanyBlock_CompanyBlock_css__WEBPACK_IMPORTED_MODULE_0__/* .ViewAllButton */ .og);
var MostUsageTitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_Container_Container_css__WEBPACK_IMPORTED_MODULE_1__/* .Title */ .D).withConfig({
    componentId: "sc-1668e65a-1"
})(_templateObject1());
var ButtonWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-1668e65a-2"
})(_templateObject2());
var CVPreview = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].a.withConfig */ .ZP.a.withConfig({
    componentId: "sc-1668e65a-3"
})(_templateObject4(), ButtonWrapper, function(param) {
    var isFullWidth = param.isFullWidth;
    if (!isFullWidth) {
        return "";
    }
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject3());
});


/***/ }),

/***/ 71187:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dt": function() { return /* binding */ UploadFileItem; },
/* harmony export */   "Fu": function() { return /* binding */ TagSearchable; },
/* harmony export */   "KO": function() { return /* binding */ CustomLabelSingleRadio; },
/* harmony export */   "LO": function() { return /* binding */ CVTitle; },
/* harmony export */   "Lb": function() { return /* binding */ RenameContent; },
/* harmony export */   "OT": function() { return /* binding */ CustomSingleRadio; },
/* harmony export */   "Rn": function() { return /* binding */ DeleteContent; },
/* harmony export */   "UL": function() { return /* binding */ FileInfo; },
/* harmony export */   "V1": function() { return /* binding */ TitleH3; },
/* harmony export */   "WY": function() { return /* binding */ WarningAlert; },
/* harmony export */   "Yl": function() { return /* binding */ AttachedCVWrapper; },
/* harmony export */   "Z_": function() { return /* binding */ CVSection; },
/* harmony export */   "dF": function() { return /* binding */ CVText; },
/* harmony export */   "dV": function() { return /* binding */ UploadRowTitle; },
/* harmony export */   "dm": function() { return /* binding */ ColPdfView; },
/* harmony export */   "eU": function() { return /* binding */ FileLabel; },
/* harmony export */   "hW": function() { return /* binding */ ErrorLabel; },
/* harmony export */   "i3": function() { return /* binding */ SearchableTag; },
/* harmony export */   "kx": function() { return /* binding */ CustomPopup; },
/* harmony export */   "l9": function() { return /* binding */ UploadRowContent; },
/* harmony export */   "mE": function() { return /* binding */ UploadColViewMore; },
/* harmony export */   "mI": function() { return /* binding */ CVSectionTitle; },
/* harmony export */   "o8": function() { return /* binding */ AttachIcon; },
/* harmony export */   "oz": function() { return /* binding */ UploadRowBottomTag; },
/* harmony export */   "pH": function() { return /* binding */ LeftSideContent; },
/* harmony export */   "pi": function() { return /* binding */ CVReplaceContent; },
/* harmony export */   "tC": function() { return /* binding */ ActionItem; },
/* harmony export */   "tv": function() { return /* binding */ CustomSkeleton; },
/* harmony export */   "xO": function() { return /* binding */ UploadColFilename; },
/* harmony export */   "y2": function() { return /* binding */ SpanTitle; }
/* harmony export */ });
/* unused harmony exports UploadFileInput, NoAttachmentResult, NoAttachmentTitle, NoAttachmentDescription, NoAttachmentAction, CVTemplateList, PdfPreview, AttachedCVButtonWrapper, ProgressBarItem, Progress */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19521);
/* harmony import */ var _Dashboard_MostUsageCV_MostUsageCV_css__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46114);
/* harmony import */ var _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33089);
/* harmony import */ var _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39724);
/* harmony import */ var _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18978);
/* harmony import */ var _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8918);
/* harmony import */ var _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(12056);
/* harmony import */ var _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(19357);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    margin: 0 0 16px 0;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    flex-direction: column;\n    padding: 24px;\n    border-radius: 12px;\n    background: #FFF;\n    align-items: flex-start;\n    margin-top: ",
        ";\n    margin-bottom: 12px;\n    ",
        " {\n        background: #EFF5FF;\n        padding: 16px;\n        border-radius: 12px;\n        width: 100%;\n    }\n    &:last-child {\n        margin-bottom: 0;\n    }\n    @media screen and (max-width: 768px) {\n        background-color: ",
        ";\n        padding: 12px;\n    }\n    > label {\n        > div {\n            flex-direction: column;\n        }\n    }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    opacity: 0;\n    position: absolute;\n    pointer-events: none;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n    color: ",
        ";\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 40px;\n    margin-bottom: 16px;\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    > button {\n        color: ",
        ";\n        > svg {\n            margin-right: 6px;\n        }\n    }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n    padding: 32px;\n    background: #F9F9F9;\n    display: flex;\n    border-radius: 6px;\n    flex-direction: column;\n    align-items: center;\n    width: 100%;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n    color: #333;\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 18px;\n    text-align: center;\n    margin-top: 16px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n    color: #939393;\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 18px;\n    text-align: center;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n    overflow: hidden;\n    white-space: nowrap;\n    width: 100%;\n    a {\n        display: inline-flex;\n    }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n            padding-top: 4px;\n            flex-direction: column;\n        "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n    position: relative;\n    width: 100%;\n    padding: 16px;\n    display: flex;\n    justify-content: space-between;\n    background-color: #fff;\n    border-radius: 12px;\n    margin-bottom: 8px;\n    border: 1px solid #fff;\n    &:last-child {\n        margin-bottom: 0;\n    }\n    &:hover {\n        background-color: ",
        ";\n        border: 1px solid ",
        ";\n    }\n    ",
        "\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n    width: calc(100% - 40px);\n    display: flex;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n    line-height: 20px;\n    font-weight: 500;\n    color: #333;\n    font-size: 16px;\n    font-size: 16px;\n    display: flex;\n    justify-content: flex-start;\n    @media screen and (max-width: 768px) {\n        flex-direction: column;\n    }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n    line-height: 20px;\n    font-weight: 400;\n    color: ",
        ";\n    font-size: 14px;\n    margin-top: 8px;\n    display: flex;\n    justify-content: flex-start;\n    @media screen and (max-width: 768px) {\n        flex-direction: column;\n    }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n            width: 100%;\n        "
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "\n    ",
        "\n    ::before {\n        content: attr(data-filename);\n        text-overflow: ellipsis;\n        display: inline-block;\n        max-width: ",
        ";\n        overflow: hidden;\n        white-space: pre;\n    }\n    ::after {\n        content: attr(data-extension);\n        text-overflow: clip;\n        display: inline-block;\n        max-width: ",
        "px;\n        min-width: ",
        "px;\n        overflow: hidden;\n        white-space: pre;\n    }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _taggedTemplateLiteral([
        "\n                width: 100%;\n            "
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _taggedTemplateLiteral([
        "\n            width: fit-content;\n            max-width: calc(100% - ",
        "px);\n        "
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _taggedTemplateLiteral([
        "\n            width: 100%;\n        "
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _taggedTemplateLiteral([
        "\n    font-size: 16px;\n    margin-right: 6px;\n    ",
        ";\n    ::before {\n        content: attr(data-filename);\n        text-overflow: ellipsis;\n        display: inline-block;\n        max-width: ",
        " !important;\n        overflow: hidden;\n        white-space: pre;\n    }\n    ::after {\n        content: attr(data-extension);\n        text-overflow: clip;\n        display: inline-block;\n        max-width: 10%;\n        min-width: ",
        "px;\n        width: 26px;\n        overflow: hidden;\n        white-space: pre;\n    }\n    @media screen and (min-width: 768px) and (max-width: 825px) {\n        ::before {\n            max-width: 80%;\n        }\n        ::after {\n            max-width: 20%;\n        }\n    }\n    @media screen and (min-width: 825px) and (max-width: 846px) {\n        ::before {\n            max-width: 86%;\n        }\n        ::after {\n            max-width: 14%;\n        }\n    }\n    @media screen and (min-width: 847px) and (max-width: 922px) {\n        ::before {\n            max-width: 88%;\n        }\n        ::after {\n            max-width: 12%;\n        }\n    }\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _taggedTemplateLiteral([
        "\n    color: #333;\n    font-size: 14px;\n    line-height: 18px;\n    display: flex;\n    margin-bottom: 4px;\n    &:last-child {\n        margin-bottom: 0;\n    }\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = _taggedTemplateLiteral([
        "\n    width: 88px;\n    height: 124px;\n    margin-right: 16px;\n    border: none;\n    pointer-events: none;\n    overflow: hidden !important;\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = _taggedTemplateLiteral([
        "\n    width: calc(100% - 52px);\n    max-width: calc(100% - 52px);\n    @media screen and (max-width: 768px) {\n        width: 100%;\n        max-width: 100%;\n    }\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = _taggedTemplateLiteral([
        "\n            position: absolute;\n            right: -1px;\n            bottom: -1px;\n            border-radius: 12px 0 12px 0;\n        "
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = _taggedTemplateLiteral([
        "\n    min-width: 100px;\n    background-color: ",
        ";\n    color: ",
        ";\n    border-radius: 14px;\n    display: flex !important;\n    height: 24px;\n    padding: 2px 8px;\n    align-items: center;\n    font-size: 12px;\n    font-weight: 500;\n    line-height: 14px;\n    justify-content: center;\n    ",
        "\n"
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = _taggedTemplateLiteral([
        "\n    width: 100%;\n    margin-top: 16px;\n    > button {\n        width: 100%;\n    }\n"
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = _taggedTemplateLiteral([
        "\n    0% {\n        background-position-x: 32px;\n    }\n"
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = _taggedTemplateLiteral([
        "\n    border-radius: 5px;\n    background-color: #d9e6ff;\n    width: 100%;\n    width: 386px;\n    height: 10px;\n    position: relative;\n    overflow: hidden;\n"
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = _taggedTemplateLiteral([
        "\n            animation: 1s linear infinite ",
        ";\n            background-image: linear-gradient(\n                45deg,\n                rgba(255, 255, 255, 0.15) 25%,\n                transparent 25%,\n                transparent 50%,\n                rgba(255, 255, 255, 0.15) 50%,\n                rgba(255, 255, 255, 0.15) 75%,\n                transparent 75%,\n                transparent\n            );\n            background-size: 32px 32px;\n        "
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = _taggedTemplateLiteral([
        "\n    background-color: ",
        ";\n    border-radius: 5px;\n    height: 10px;\n    display: flex;\n    ",
        "\n"
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = _taggedTemplateLiteral([
        "\n    border-bottom: 1px solid ",
        ";\n"
    ]);
    _templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = _taggedTemplateLiteral([
        "\n    line-height: 40px;\n    /* width: fit-content;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 1;\n    word-break: break-word; */\n    color: #333;\n    font-size: 16px;\n    font-weight: 500;\n\n    display: inline-block;\n    overflow: hidden;\n    white-space: pre;\n\n"
    ]);
    _templateObject31 = function _templateObject31() {
        return data;
    };
    return data;
}
function _templateObject32() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    justify-content: flex-end;\n"
    ]);
    _templateObject32 = function _templateObject32() {
        return data;
    };
    return data;
}
function _templateObject33() {
    var data = _taggedTemplateLiteral([
        "\n    padding-top: 8px;\n"
    ]);
    _templateObject33 = function _templateObject33() {
        return data;
    };
    return data;
}
function _templateObject34() {
    var data = _taggedTemplateLiteral([
        "\n    width: 64px;\n    /* height: 80px; */\n    min-height: 46px;\n    border-radius: 6px;\n    overflow: hidden;\n    border: 1px solid #fff;\n    ",
        " {\n        width: 64px;\n        overflow: hidden;\n    }\n"
    ]);
    _templateObject34 = function _templateObject34() {
        return data;
    };
    return data;
}
function _templateObject35() {
    var data = _taggedTemplateLiteral([
        "\n    height: 14px;\n"
    ]);
    _templateObject35 = function _templateObject35() {
        return data;
    };
    return data;
}
function _templateObject36() {
    var data = _taggedTemplateLiteral([
        "\n    padding: 8px;\n    text-align: center;\n    p {\n        margin-bottom: 16px;\n        word-break: break-word;\n        &:last-child {\n            margin: 0;\n        }\n    }\n"
    ]);
    _templateObject36 = function _templateObject36() {
        return data;
    };
    return data;
}
function _templateObject37() {
    var data = _taggedTemplateLiteral([
        '\n    text-align: center;\n    padding: 8px 8px 0 8px;\n    > p {\n        margin: 0 0 16px 0;\n    }\n    > b {\n        font-size: 16px;\n        font-weight: 600;\n        line-height: 20px;\n    }\n    [name="replace-attached-cv"] {\n        p {\n            text-align: left;\n        }\n    }\n    ul {\n        margin-top: 8px;\n        margin-bottom: 0;\n        padding-left: 0;\n    }\n    @media screen and (max-width: 768px) {\n        ul {\n            padding: 0;\n        }\n    }\n'
    ]);
    _templateObject37 = function _templateObject37() {
        return data;
    };
    return data;
}
function _templateObject38() {
    var data = _taggedTemplateLiteral([
        "\n    @media screen and (min-width: 769px) {\n        .vnw-popup-content {\n            width: 520px !important;\n        }\n    }\n"
    ]);
    _templateObject38 = function _templateObject38() {
        return data;
    };
    return data;
}
function _templateObject39() {
    var data = _taggedTemplateLiteral([
        "\n            background-color: ",
        ";\n        "
    ]);
    _templateObject39 = function _templateObject39() {
        return data;
    };
    return data;
}
function _templateObject40() {
    var data = _taggedTemplateLiteral([
        "\n    border-radius: 8px;\n    ",
        "\n    p {\n        text-align: left;\n    }\n"
    ]);
    _templateObject40 = function _templateObject40() {
        return data;
    };
    return data;
}
function _templateObject41() {
    var data = _taggedTemplateLiteral([
        "\n    text-align: left;\n    display: flex;\n    align-items: center;\n"
    ]);
    _templateObject41 = function _templateObject41() {
        return data;
    };
    return data;
}
function _templateObject42() {
    var data = _taggedTemplateLiteral([
        "\n                width: calc(100% - 120px);\n            "
    ]);
    _templateObject42 = function _templateObject42() {
        return data;
    };
    return data;
}
function _templateObject43() {
    var data = _taggedTemplateLiteral([
        "\n            width: 100%;\n        "
    ]);
    _templateObject43 = function _templateObject43() {
        return data;
    };
    return data;
}
function _templateObject44() {
    var data = _taggedTemplateLiteral([
        "\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n    ::before {\n        content: attr(data-filename);\n        text-overflow: ellipsis;\n        display: inline-block;\n        max-width: ",
        " !important;\n        overflow: hidden;\n        white-space: pre;\n    }\n    ::after {\n        content: attr(data-extension);\n        text-overflow: clip;\n        display: inline-block;\n        max-width: ",
        "px;\n        min-width: ",
        "px;\n        overflow: hidden;\n        white-space: pre;\n    }\n    ",
        "\n"
    ]);
    _templateObject44 = function _templateObject44() {
        return data;
    };
    return data;
}
function _templateObject45() {
    var data = _taggedTemplateLiteral([
        "\n    border-radius: 14px;\n    margin-left: 8px;\n    font-size: 12px;\n    font-weight: 500;\n    line-height: 14px;\n    padding: 2px 6px;\n    background-color: ",
        ";\n    color: ",
        ";\n    flex-shrink: 0;\n"
    ]);
    _templateObject45 = function _templateObject45() {
        return data;
    };
    return data;
}
function _templateObject46() {
    var data = _taggedTemplateLiteral([
        "\n    background-color: ",
        ";\n    border-radius: 8px;\n    padding: 8px;\n    display: flex;\n    > div {\n        margin-left: 8px;\n        text-align: left;\n    }\n"
    ]);
    _templateObject46 = function _templateObject46() {
        return data;
    };
    return data;
}
function _templateObject47() {
    var data = _taggedTemplateLiteral([
        "\n    margin-bottom: 8px;\n    border-radius: 12px;\n    &:first-child {\n        margin-top: 8px;\n    }\n    &:last-child {\n        margin-bottom: 0;\n    }\n"
    ]);
    _templateObject47 = function _templateObject47() {
        return data;
    };
    return data;
}
function _templateObject48() {
    var data = _taggedTemplateLiteral([
        "\n    width: 40px;\n    min-height: 46px;\n    display: flex;\n    align-items: center;\n    padding-right: 16px;\n    @media screen and (max-width: 768px) {\n        width: 100%;\n        height: 100%;\n        justify-content: center;\n    }\n"
    ]);
    _templateObject48 = function _templateObject48() {
        return data;
    };
    return data;
}
function _templateObject49() {
    var data = _taggedTemplateLiteral([
        "\n\n"
    ]);
    _templateObject49 = function _templateObject49() {
        return data;
    };
    return data;
}
function _templateObject50() {
    var data = _taggedTemplateLiteral([
        "\n    display: inline-block;\n    margin-bottom: 0;\n    font-size: 12px;\n    color: #FF4A53;\n    margin-top: 4px;\n"
    ]);
    _templateObject50 = function _templateObject50() {
        return data;
    };
    return data;
}



var AttachedCVWrapper = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-819a129c-0"
})(_templateObject());
var CVSection = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-819a129c-1"
})(_templateObject1(), function(param) {
    var isFirst = param.isFirst;
    return isFirst ? "0" : "16px";
}, _Dashboard_MostUsageCV_MostUsageCV_css__WEBPACK_IMPORTED_MODULE_0__/* .MostUsageCVWrapper */ .EJ, _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_2__/* .colors.neutral[95] */ .O9.neutral[95]);
var UploadFileInput = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].input.withConfig */ .ZP.input.withConfig({
    componentId: "sc-819a129c-2"
})(_templateObject2());
var CVSectionTitle = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].h2.withConfig */ .ZP.h2.withConfig({
    componentId: "sc-819a129c-3"
})(_templateObject3(), _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_2__/* .colors.neutral[50] */ .O9.neutral[50], _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_2__/* .colors.primary[40] */ .O9.primary[40]);
var NoAttachmentResult = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-819a129c-4"
})(_templateObject4());
var NoAttachmentTitle = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].p.withConfig */ .ZP.p.withConfig({
    componentId: "sc-819a129c-5"
})(_templateObject5());
var NoAttachmentDescription = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].p.withConfig */ .ZP.p.withConfig({
    componentId: "sc-819a129c-6"
})(_templateObject6());
var NoAttachmentAction = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-819a129c-7"
})(_templateObject7());
var CVTemplateList = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-819a129c-8"
})(_templateObject8());
var UploadFileItem = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-819a129c-9"
})(_templateObject10(), _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_2__/* .colors.primary[99] */ .O9.primary[99], _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_2__/* .colors.primary[90] */ .O9.primary[90], function(param) {
    var isMobile = param.isMobile;
    if (!isMobile) {
        return "";
    }
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject9());
});
var LeftSideContent = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-819a129c-10"
})(_templateObject11());
var CVTitle = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].a.withConfig */ .ZP.a.withConfig({
    componentId: "sc-819a129c-11"
})(_templateObject12());
var ActionItem = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].a.withConfig */ .ZP.a.withConfig({
    componentId: "sc-819a129c-12"
})(_templateObject13(), _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_2__/* .colors.primary[40] */ .O9.primary[40]);
var SpanTitle = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-819a129c-13"
})(_templateObject15(), function(param) {
    var isMobile = param.isMobile;
    if (!isMobile) {
        return "";
    }
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject14());
}, function(param) {
    var minWidth = param.minWidth;
    return "calc(100% - ".concat(minWidth, "px)");
}, function(param) {
    var minWidth = param.minWidth;
    return minWidth;
}, function(param) {
    var minWidth = param.minWidth;
    return minWidth;
});
var TitleH3 = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
    componentId: "sc-819a129c-14"
})(_templateObject19(), function(param1) {
    var isMobile = param1.isMobile, isHaveSearchable = param1.isHaveSearchable;
    if (isMobile) {
        return (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject16());
    }
    return isHaveSearchable ? (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject17(), function(param) {
        var isLangVN = param.isLangVN;
        return isLangVN ? 140 : 100;
    }) : (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject18());
}, function(param) {
    var minWidth = param.minWidth;
    return "calc(100% - ".concat(minWidth, "px)");
}, function(param) {
    var minWidth = param.minWidth;
    return minWidth;
});
var CVText = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-819a129c-15"
})(_templateObject20());
var PdfPreview = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].iframe.withConfig */ .ZP.iframe.withConfig({
    componentId: "sc-819a129c-16"
})(_templateObject21());
var FileInfo = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-819a129c-17"
})(_templateObject22());
var TagSearchable = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-819a129c-18"
})(_templateObject24(), _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_2__/* .colors.green[90] */ .O9.green[90], _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_2__/* .colors.green[50] */ .O9.green[50], function(param) {
    var isMobile = param.isMobile;
    if (!isMobile) {
        return "";
    }
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject23());
});
var AttachedCVButtonWrapper = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-819a129c-19"
})(_templateObject25());
var progressBarStripes = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .keyframes */ .F4)(_templateObject26());
var ProgressBarItem = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-819a129c-20"
})(_templateObject27());
var Progress = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-819a129c-21"
})(_templateObject29(), function(param) {
    var color = param.color;
    return color !== null && color !== void 0 ? color : _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_2__/* .colors.primary[40] */ .O9.primary[40];
}, function(param) {
    var isUploading = param.isUploading;
    if (!isUploading) {
        return "";
    }
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject28(), progressBarStripes);
});
var UploadRowTitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_microfrontends_react_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-819a129c-22"
})(_templateObject30(), _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_2__/* .colors.neutral[95] */ .O9.neutral[95]);
var UploadColFilename = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_microfrontends_react_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
    componentId: "sc-819a129c-23"
})(_templateObject31());
var UploadColViewMore = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_microfrontends_react_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
    componentId: "sc-819a129c-24"
})(_templateObject32());
var UploadRowContent = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_microfrontends_react_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-819a129c-25"
})(_templateObject33());
var ColPdfView = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_microfrontends_react_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
    componentId: "sc-819a129c-26"
})(_templateObject34(), PdfPreview);
var UploadRowBottomTag = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_microfrontends_react_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-819a129c-27"
})(_templateObject35());
var DeleteContent = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-819a129c-28"
})(_templateObject36());
var CVReplaceContent = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-819a129c-29"
})(_templateObject37());
var CustomPopup = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_microfrontends_react_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).withConfig({
    componentId: "sc-819a129c-30"
})(_templateObject38());
var CustomSingleRadio = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_microfrontends_react_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).withConfig({
    componentId: "sc-819a129c-31"
})(_templateObject40(), function(param) {
    var isActive = param.isActive;
    if (!isActive) {
        return "";
    }
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject39(), _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_2__/* .colors.primary[95] */ .O9.primary[95]);
});
var CustomLabelSingleRadio = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-819a129c-32"
})(_templateObject41());
var FileLabel = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-819a129c-33"
})(_templateObject44(), function(param) {
    var minWidth = param.minWidth;
    return "calc(100% - ".concat(minWidth, "px)");
}, function(param) {
    var minWidth = param.minWidth;
    return minWidth;
}, function(param) {
    var minWidth = param.minWidth;
    return minWidth;
}, function(param) {
    var isSearchable = param.isSearchable;
    if (isSearchable) {
        return (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject42());
    }
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject43());
});
var SearchableTag = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-819a129c-34"
})(_templateObject45(), _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_2__/* .colors.green[90] */ .O9.green[90], _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_2__/* .colors.green[50] */ .O9.green[50]);
var WarningAlert = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-819a129c-35"
})(_templateObject46(), _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_2__/* .colors.yellow[95] */ .O9.yellow[95]);
var CustomSkeleton = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_microfrontends_react_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z).withConfig({
    componentId: "sc-819a129c-36"
})(_templateObject47());
var AttachIcon = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].a.withConfig */ .ZP.a.withConfig({
    componentId: "sc-819a129c-37"
})(_templateObject48());
var RenameContent = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-819a129c-38"
})(_templateObject49());
var ErrorLabel = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].p.withConfig */ .ZP.p.withConfig({
    componentId: "sc-819a129c-39"
})(_templateObject50());


/***/ }),

/***/ 51026:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BI": function() { return /* binding */ LEVEL_LIST; },
/* harmony export */   "EU": function() { return /* binding */ LITMIT_DESCRIPTION; },
/* harmony export */   "F$": function() { return /* binding */ LOCATION_LIST; },
/* harmony export */   "Fe": function() { return /* binding */ DEFAULT_MIN_WIDTH; },
/* harmony export */   "GK": function() { return /* binding */ SKILL_NAME_LIMITED_CHAR; },
/* harmony export */   "Lo": function() { return /* binding */ LOCATION_LIST_EN; },
/* harmony export */   "RX": function() { return /* binding */ proficiencySkillLevel; },
/* harmony export */   "Ym": function() { return /* binding */ MAX_CHAR; },
/* harmony export */   "dv": function() { return /* binding */ INTERNSHIP_ID; },
/* harmony export */   "i0": function() { return /* binding */ noSpecialCharsForJobTitle; },
/* harmony export */   "jz": function() { return /* binding */ proficiencyLevel; },
/* harmony export */   "qL": function() { return /* binding */ CHARACTER_LENGTH; },
/* harmony export */   "yE": function() { return /* binding */ FRESHER_ID; },
/* harmony export */   "z4": function() { return /* binding */ LEVEL_LIST_EN; }
/* harmony export */ });
/* unused harmony exports noSpecialChars, noSpecialCharsButNumber, numericOnly, numericAndCommaOnly, UNCONTACTABLE_ERROR_CODE */
/* harmony import */ var _microfrontends_app_shell_v2__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64889);
/* eslint-disable no-useless-escape */ 
var proficiencyLevel = [
    {
        id: 1,
        name: "S\u01A1 C\u1EA5p",
        nameEn: "Beginner",
        bgColor: "#f8c603"
    },
    {
        id: 2,
        name: "Trung C\u1EA5p",
        nameEn: "Intermediate",
        bgColor: "#FF7D55"
    },
    {
        id: 3,
        name: "Cao C\u1EA5p",
        nameEn: "Advanced",
        bgColor: "#005aff"
    },
    {
        id: 4,
        name: "B\u1EA3n \u0110\u1ECBa",
        nameEn: "Native",
        bgColor: "#7ac123"
    }
];
var proficiencySkillLevel = [
    {
        id: 1,
        name: "1",
        bgColor: "#999999"
    },
    {
        id: 2,
        name: "2",
        bgColor: "#F7BE06"
    },
    {
        id: 3,
        name: "3",
        bgColor: "#FF7D55"
    },
    {
        id: 4,
        name: "4",
        bgColor: "#005aff"
    },
    {
        id: 5,
        name: "5",
        bgColor: "#6FB920"
    }
];
var INTERNSHIP_ID = 8;
var FRESHER_ID = 1;
var noSpecialChars = /[-0-9#@!$%^&*()_+|~=`{}\[\]:";'<>?,.\/]/;
var noSpecialCharsButNumber = /[#@!$%^&*()_+|~=`{}\[\]:";'<>?,.\/]/;
var noSpecialCharsForJobTitle = /[@!$%^*()_|~=`{}\[\]:";'<>?,]/;
var numericOnly = /^-?\d*(\.\d*)?$/;
var numericAndCommaOnly = /(,*[\d]+,*[\d]*)+/;
var MAX_CHAR = 5000;
var LOCATION_LIST = _microfrontends_app_shell_v2__WEBPACK_IMPORTED_MODULE_0__/* .initialDataProvider.getLocations */ .Bz.getLocations();
var LOCATION_LIST_EN = LOCATION_LIST.map(function(item) {
    return {
        id: item.id,
        name: item.nameEn
    };
});
var LEVEL_LIST = _microfrontends_app_shell_v2__WEBPACK_IMPORTED_MODULE_0__/* .initialDataProvider.getLevels */ .Bz.getLevels();
var LEVEL_LIST_EN = LEVEL_LIST.map(function(item) {
    return {
        id: item.id,
        name: item.nameEn
    };
});
var SKILL_NAME_LIMITED_CHAR = 40;
var UNCONTACTABLE_ERROR_CODE = "UC001";
var LITMIT_DESCRIPTION = 5000;
var CHARACTER_LENGTH = 10.5;
var DEFAULT_MIN_WIDTH = 25;


/***/ }),

/***/ 42996:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "cP": function() { return /* binding */ companyFollow; },
/* harmony export */   "se": function() { return /* binding */ DEFAULT_SUCCESS_CODE; }
/* harmony export */ });
/* unused harmony exports DEFAULT_ERROR_CODE, companyDetailService */
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96306);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}


var DEFAULT_SUCCESS_CODE = 200;
var DEFAULT_ERROR_CODE = 400;
var COMPANY_DETAIL_API = "https://ms.vietnamworks.com" + "/company-profile/v1.0/company-profile/detail";
var COMPANY_FOLLOW_API = "".concat("https://ms.vietnamworks.com", "/api-gateway/v1.0/profile/follow");
var companyDetailService = function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(data, userId, langCode) {
        var body, requestOptions, responseCompanyDetail;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    body = _defineProperty({
                        userId: userId
                    }, data.type, Number(data.id));
                    requestOptions = {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            "Accept-Language": langCode || _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_1__/* .ELanguage.VI */ .Df.VI
                        },
                        body: JSON.stringify(body)
                    };
                    _ctx.next = 5;
                    return fetch(COMPANY_DETAIL_API, requestOptions);
                case 5:
                    responseCompanyDetail = _ctx.sent;
                    _ctx.next = 8;
                    return responseCompanyDetail.json();
                case 8:
                    return _ctx.abrupt("return", _ctx.sent);
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        meta: {
                            code: DEFAULT_ERROR_CODE,
                            message: "ERROR"
                        },
                        data: null
                    });
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                11
            ]
        ]);
    }));
    return function companyDetailService(data, userId, langCode) {
        return _ref.apply(this, arguments);
    };
}();
var companyFollow = function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(companyId, isFollow, accessToken, langCode) {
        var postData, requestOptions, response;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    postData = {
                        companyId: companyId,
                        status: isFollow ? 1 : 0
                    };
                    requestOptions = {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            "Accept-Language": langCode || _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_1__/* .ELanguage.VI */ .Df.VI,
                            Authorization: "Bearer ".concat(accessToken)
                        },
                        body: JSON.stringify(postData)
                    };
                    _ctx.next = 5;
                    return fetch(COMPANY_FOLLOW_API, requestOptions);
                case 5:
                    response = _ctx.sent;
                    _ctx.next = 8;
                    return response.json();
                case 8:
                    return _ctx.abrupt("return", _ctx.sent);
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](0);
                    console.error(_ctx.t0);
                    return _ctx.abrupt("return", {
                        meta: {
                            code: DEFAULT_ERROR_CODE,
                            message: "ERROR"
                        },
                        data: null
                    });
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                11
            ]
        ]);
    }));
    return function companyFollow(companyId, isFollow, accessToken, langCode) {
        return _ref.apply(this, arguments);
    };
}();


/***/ })

}]);